import { adminCatalogMockData, adminCatalogItemMockData } from "../data";
import {
  AdminCatalogForm,
  AdminCatalogItemForm,
  AdminCatalogState,
} from "../types/index";

export const initialAdminCatalogForm: AdminCatalogForm = {
  catalogName: "",
  description: "",
  amountOfItems: "",
  mainInfluenceField: "",
  visualIntegration: "",
};

export const initialAdminCatalogItemForm: AdminCatalogItemForm = {
  itemCode: "",
  itemName: "",
  profileHeight: "",
  weightPerMeter: "",
  technicalNote: "",
};

export const initialState: AdminCatalogState = {
  catalogData: adminCatalogMockData,
  CatalogItems: adminCatalogItemMockData,
  loading: false,
  isAddModalOpen: false,
  isAddItemModalOpen: false,
  form: initialAdminCatalogForm,
  itemForm: initialAdminCatalogItemForm,
};
